// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if ({ "index":1,"lib-react":1,"lib-router":1,"vendors-node_modules_ant-design_icons_es_icons_ArrowLeftOutlined_js-node_modules_ant-design_i-472c22":1 }[chunkId]) return "static/js/" + chunkId + ".js";
  // return url for filenames based on template
  return "static/js/async/" + chunkId + ".js"
}